
import { useRef } from "react";
import { Paper, Stack, Typography } from "@mui/material";
import CustomAreaChart from "../charts/CustomAreaChart";
import DataPointDelta from "../DataPointDelta";

const IndicatorCardChart = ({ indicator, currentIndicator, history, flex }) => {

    const chartRef = useRef(null)

    return (
        <Stack sx={{ flex: flex, p: 2 }} component={Paper} gap={2}>
            <Typography variant="subtitle1" fontWeight="bold">{history.label}</Typography>
            <DataPointDelta
                label="Value"
                currentValue={indicator.target.value}
                referenceValue={indicator.offset.value}
                referenceTimeRange="1M"
                unit={currentIndicator === "averageExchangeRate" ? "₡" : "%"}
            />
            <CustomAreaChart chartData={history} chartRef={chartRef} />
        </Stack>
    );
};

export default IndicatorCardChart;